module.exports = "pegasus/assets/hexagon-tumblr.png";